import React from "react";
import TitleText from "../common/title-text/title-text";
import { useState, useEffect } from "react";
import MainSlider from "../common/main-slider/main-slider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Swiper as SwiperCore } from "swiper";
import "./styles.scss";

const withUrl = (imageName) => `${imageName}.jpg`;
SwiperCore.use([Navigation, Pagination]);

export default function GallerySlider({ data }) {
  // const slides = data.map(({ title, text, imageName }, i) => (
  //   <div className='gallery-images' role='presentation' key={i}>
  //     <div className='gallery-image'>
  //       <img
  //         srcSet={`
  //           ${withUrl(`${imageName}_800x600`)} 800w,
  //           ${withUrl(`${imageName}_1600x900`)} 1600w,
  //           ${withUrl(`${imageName}_3840x2160`)} 3840w,
  //         `}
  //         sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, 3840px`}
  //         src={`${withUrl(`${imageName}_1600x900`)}`}
  //         alt='property'
  //       />
  //     </div>
  //     <div className='simple-gallery__info'>
  //       <h3>{title}</h3>
  //       <p>{text}</p>
  //     </div>
  //   </div>
  // ));
  const [slideInfo, setSlideInfo] = useState({
    title: "",
    text: "",
  });

  useEffect(() => {
    const slide = data[0];
    if (slide && slide.title !== slideInfo.title) {
      setSlideInfo({ title: slide.title, text: slide.text });
    }
  }, []);

  const createImageCarousel = () => {
    const images = [];
    let image;
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        const imageName = data[i].imageName;
        image = (
          <div className='gallery-images' role='presentation' key={i}>
            <div className='gallery-image'>
              <img
                srcSet={`
            ${withUrl(`${imageName}_800x600`)} 800w,
            ${withUrl(`${imageName}_1600x900`)} 1600w,
            ${withUrl(`${imageName}_3840x2160`)} 3840w,
          `}
                sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, 3840px`}
                src={`${withUrl(`${imageName}_1600x900`)}`}
                alt='property'
              />
            </div>
          </div>
        );
        images.push(image);
      }
    }
    return images;
  };

  const info = (
    <div className='gallery-slider__info' id='gallery-info'>
      <h3>{slideInfo.title}</h3>
      <p>{slideInfo.text}</p>
    </div>
  );

  const images = createImageCarousel();
  return (
    <div className='gallery-slider'>
      <TitleText isCentered as='h2' variant={"primary"} color='color-5'>
        Gallery
      </TitleText>
      {/* <MainSlider theme='light'>{slides}</MainSlider> */}
      <div className='main-slider'>
        <Swiper
          slidesPerView={1}
          speed={700}
          autoPlay={{
            delay: 2000,
          }}
          loop
          navigation
          pagination={{ clickable: true }}
          className='swiper-theme-light'
          onSlideChange={(swiper) => {
            const index = swiper.realIndex;
            const slide = data[index];
            if (slide && slide.title !== slideInfo.title) {
              setSlideInfo({ title: slide.title, text: slide.text });
              document.getElementById("gallery-info").classList.add("update-title");
              setTimeout(() => {
                document.getElementById("gallery-info").classList.remove("update-title");
              }, 500);
            }
          }}
        >
          {images.map((item, index) => (
            <SwiperSlide key={index}>{item}</SwiperSlide>
          ))}
        </Swiper>
        {info}
      </div>
    </div>
  );
}
